import format from 'date-fns/format';

/**
 * get the current datetime string (in EST)
 * @returns {string}
 * // TODO this is currently too naive. Needs to use a third-party to establish a more accurate time than the clients time
 */
export default function getTime() {
    const date = new Date();
    return format(date);
}


// WEBPACK FOOTER //
// ./assets/js/app/lib/time.js